import React, { useEffect, useRef, useState } from 'react'
import './secret-codes-landing.styles.scss';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import SecretCodesList from './secret-codes-list.component';
import SecretCodesForm from './secret-codes-form.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import { properCase } from '@/utils/properCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUpload } from '@fortawesome/free-solid-svg-icons';
import SecretCodesUpload from './secret-codes-upload.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';
import { useEffectiveMembership } from '@/utils/useEffectiveMembership';


const SecretCodesLandingPage = ({
    gameElements,
    gameStats,
    gameData,
    playerList,
    role
}) => {
    
    const membership = useEffectiveMembership();
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ secretCodesFromDb, setSecretCodesFromDb ] = useState({});
    const [ secretCodesRetrieved, setSecretCodesRetrieved ] = useState(false);
    const secretCodesRef = useRef();
    let secretCodesListener;
    const navigate = useNavigate();

    useEffect(() => {
        checkMembership();

        return () => {
            if (secretCodesListener) secretCodesListener();
        }
    }, [])

    useEffect(() => {
        if (!gameData || secretCodesRetrieved) return;
        getGameElementsToManage();
        setSecretCodesRetrieved(true);
    }, [gameData])

    function checkMembership(e) {
        const element = 'secretCodes'
        const res = testMemberRestrictions({'gameData': gameData, 'membership': membership, 'element': element})
        // console.log(res);

        if (res.disabled) {
            let message = ''
            const planRest = membershipRestrictions[membership.membership];
            if (res.disabledReason.includes(element)) {
                message = `While using the ${planRest.title}, you are not able to access Secret Codes.`;
            }
            setShowUpgradeModal(message)
            return;   
        }
    }

    function getGameElementsToManage() {
        if (location.pathname.includes('/preview/manager/')) {
            const secretCodeObj = {};
            Object.values(completeGameElementData)
                .filter(e => e.type === 'secretCode' && e.status === 'active')
                .forEach(e => {
                    secretCodeObj[e.id] = e;
                });
            setSecretCodesFromDb(secretCodeObj);
            return;
        }
        getCollectionFromDb({
            "collection": `games/${gameData.gameId}/gameElements`,
            "query1": {
                "key": "type",
                "condition": "==",
                "value": "secretCode"
            },
            "callback": callback,
            "handleListener": handleListener
        })
        function callback(data) {
            secretCodesRef.current = {
                ...secretCodesRef.current,
                ...{[data.id]: data}
            }
            setSecretCodesFromDb(secretCodesRef.current);
        }
        function handleListener(data) {
            secretCodesListener = data;
        }
    }
    
    return (
        <div className='secret-codes-landing'>
            <Routes>
                <Route path='' element={
                    <div className='g-card secret-codes-card'>
                        <BackButton cancel={() => navigate(-1)} />
                        <div className="g-space-1"></div>
                        <div className='card-title'>
                            <ImageContainer src='/images/icons/secret2.png' alt='secret codes icon' className='head-icon' />
                            Create and Edit Secret Codes
                            {/* <div className='buttons'>
                                <button 
                                    type='button' 
                                    className='g-button med-btn' 
                                    onClick={() => checkMembership('create')}>
                                    Create New Code
                                    <FontAwesomeIcon icon={faPlus} />
                                </button>
                                <button 
                                    type='button' 
                                    className='g-button med-btn' 
                                    onClick={() => checkMembership('upload')}>
                                    <FontAwesomeIcon icon={faUpload} />
                                </button>
                            </div> */}
                        </div>
                        <hr />
                        <div className='secret-codes-landing-content'>
                            <SecretCodesList
                                gameElements={gameElements}
                                secretCodesFromDb={secretCodesFromDb}
                                gameData={gameData}
                                role={role}
                            />
                        </div>
                    </div>
                }></Route>
                <Route path='create' element={
                    <SecretCodesForm
                        gameElements={gameElements}
                        secretCodesFromDb={secretCodesFromDb}
                        gameData={gameData}
                        gameStats={gameStats}
                        playerList={playerList}
                        role={role}  />
                }></Route>
                <Route path='edit/:secretCodePath' element={
                    <SecretCodesForm
                        gameElements={gameElements}
                        secretCodesFromDb={secretCodesFromDb}
                        gameData={gameData}
                        gameStats={gameStats}
                        playerList={playerList}
                        role={role}  />
                }></Route>
                <Route path='upload' element={
                    <SecretCodesUpload
                        gameData={gameData}
                        gameElements={gameElements}
                        secretCodesFromDb={secretCodesFromDb}
                        playerList={playerList}
                        role={role} />
                }></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
            <UpgradeRequiredModal
                show={showUpgradeModal}
                cancel={() => setShowUpgradeModal(null)}
                message={showUpgradeModal}
            />
        </div>
    )
}

export default SecretCodesLandingPage